'use strict'

define [], () ->
  ($scope, $rootScope, $http, $state, $q, RentappService, $cookies, $timeout, MIN_DESKTOP_WIDTH, applications) ->
    $scope.applications = applications.objects
    $scope.total_count = applications.meta.total_count

    $scope.pagination_options =
      for_datatable: true
    



// WEBPACK FOOTER //
// ./components/dashboard/applicant/applicant.coffee